module.exports = __webpack_public_path__ + "static/media/allview.9792e73e.jpg";